import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Context } from "../../../contexts/Store";

const PrivateRoute = ({ children }) => {
  const { state } = useContext(Context);
  const location = useLocation();

  const accessToken = state.user_details.access_token;
  const isVerified = state.user_details.is_verified;

  // If not logged in or not verified → redirect
  if (!accessToken || !isVerified) {
    return (
      <Navigate
        to={`/auth/login-page?next=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  return children;
};

export default PrivateRoute;
